import {SvgIconData} from '@shared-web/components/core/svg_icon';

export const arrowLeftIcon: SvgIconData = {
  viewBox: '0 0 24 24',
  element: <path d="M15.41 16.59 10.83 12l4.58-4.59L14 6l-6 6 6 6z"></path>,
};
